import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { DashboardContent } from "@/components/dashboard/DashboardContent"

import { useBrandAware } from '@/hooks/useBrandAware'
import { useCampaignLaunchNotifications } from '@/hooks/useCampaignLaunchNotifications'
import { useLeadEmailProviderService } from '@/hooks/useLeadEmailProviderService'
import { useLeadEmailProviderRealtime } from '@/hooks/useLeadEmailProviderRealtime'

export default function Dashboard() {
  const { getBrandStyles } = useBrandAware()
  const layoutStyles = getBrandStyles('layout')

  // Enable campaign launch notifications
  useCampaignLaunchNotifications({
    enabled: true,
    onNotificationSent: (campaignId, success) => {
      console.log(`Campaign launch notification for ${campaignId}: ${success ? 'sent' : 'failed'}`)
    }
  })

  // Enable automatic processing of new email events for lead_email_provider
  useLeadEmailProviderService()

  // Enable real-time processing of new email events
  useLeadEmailProviderRealtime()

  return (
    <NewAppLayout fullWidth>
      <div style={layoutStyles}>
        <DashboardContent />
      </div>
    </NewAppLayout>
  )
}
